import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface Profile {
  id: string;
  full_name: string;
  email: string;
  business_name?: string;
  phone?: string;
  business_type?: string;
  created_at: string;
  updated_at?: string;
}

export interface Client {
  id: string;
  user_id: string;
  full_name: string;
  email?: string;
  phone?: string;
  notes?: string;
  created_at: string;
  updated_at?: string;
}

export interface Appointment {
  id: string;
  user_id: string;
  client_id?: string;
  title: string;
  description?: string;
  start_time: string;
  end_time: string;
  status: string;
  color: string;
  created_at: string;
  updated_at?: string;
  client?: Client;
}
